import stickyHeader from "./stickyHeader.js";

const headerElement = document.querySelector(".js-header");
const headerNavElement = document.querySelector(".js-header-nav");
// offset values are esimated based on the design and may need adjustments
const siteLinksFadeOutOffset = -4;
const logoCollapseOffset = headerNavElement ? -50 : -15;

const init = function () {
	handleViewportChange();
	["scroll", "resize"].forEach((event) => {
		window.addEventListener(event, handleViewportChange);
	});
};

// eslint-disable-next-line complexity
const handleViewportChange = () => {
	if (matchMedia("(min-width: 64em)").matches) {
		document.documentElement.classList.remove("is-logo-collapsed", "is-site-links-fading-out", "is-logo-fixed");
		return;
	}
	if (!headerElement) return;

	const headerToTopOffset = stickyHeader.getHeaderToTopOffset();

	if (headerToTopOffset < 0) document.documentElement.classList.add("is-logo-fixed");
	else document.documentElement.classList.remove("is-logo-fixed");

	if (headerToTopOffset < siteLinksFadeOutOffset) document.documentElement.classList.add("is-site-links-fading-out");
	else document.documentElement.classList.remove("is-site-links-fading-out");

	if (headerToTopOffset < logoCollapseOffset) document.documentElement.classList.add("is-logo-collapsed");
	else document.documentElement.classList.remove("is-logo-collapsed");
};

export { init };
